module.exports = __webpack_public_path__ + "assets/c3cd2092520b89c381f2ed3aa97276a8.png";